/**
 * Terms of Use CSS Styles
 * Injected via style tag — matches the approved prototype exactly.
 */

const cssContent = `
  * {margin:0; padding:0; text-indent:0; }
  h1 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 12pt; }
  .p, p { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; margin:0pt; }
  .s1 { color: black; font-family:"Times New Roman", serif; font-style: italic; font-weight: bold; text-decoration: none; font-size: 12pt; }
  .a, a { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }
  .s2 { color: #00F; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: underline; font-size: 12pt; }
  .s4 { color: black; font-family:"Times New Roman", serif; font-style: italic; font-weight: normal; text-decoration: none; font-size: 12pt; }
  li {display: block; }
  #l1 {padding-left: 0pt;counter-reset: c1 1; }
  #l1> li>*:first-child:before {counter-increment: c1; content: counter(c1, decimal)". "; color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 12pt; }
  #l1> li:first-child>*:first-child:before {counter-increment: c1 0;  }
  #l2 {padding-left: 0pt; }
  #l2> li>*:first-child:before {content: "● "; color: black; font-family:Calibri, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; }
  #l3 {padding-left: 0pt;counter-reset: d1 1; }
  #l3> li>*:first-child:before {counter-increment: d1; content: counter(d1, decimal)". "; color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }
  #l3> li:first-child>*:first-child:before {counter-increment: d1 0;  }
  #l4 {padding-left: 0pt; }
  #l4> li>*:first-child:before {content: "● "; color: black; font-family:Calibri, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; }
  #l5 {padding-left: 0pt; }
  #l5> li>*:first-child:before {content: "● "; color: black; font-family:Calibri, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; }
  #l6 {padding-left: 0pt; }
  #l6> li>*:first-child:before {content: "● "; color: black; font-family:Calibri, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; }
  #l7 {padding-left: 0pt;counter-reset: e1 1; }
  #l7> li>*:first-child:before {counter-increment: e1; content: "("counter(e1, lower-latin)") "; color: black; font-family:"Times New Roman", serif; font-style: italic; font-weight: normal; text-decoration: none; font-size: 12pt; }
  #l7> li:first-child>*:first-child:before {counter-increment: e1 0;  }
`;

export const TermsOfUseStyles = () => (
  <style type="text/css" dangerouslySetInnerHTML={{ __html: cssContent }} />
);
